// Work Orders list actions: the Declined operations window, ⋯ › Print this list, and resetting
// rows excluded from the print. Split out of app.js (docs/split-plan.md, session 1). The app.js
// helpers it calls come in through setWoListActionDeps() (see estimates.js for why).
import throttle from 'lodash/throttle';
import { database } from './initFirebase';
import { escapeHTML } from './utilities';
import { equalTo, get, orderByChild, query, ref } from 'firebase/database';

let shell = null;
export function setWoListActionDeps(deps) { shell = deps; }

async function openDeclinedOperationsModal() {
  let modal = document.getElementById('declined-ops-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'declined-ops-modal';
    modal.className = 'large-modal';
    modal.style.display = 'none';
    modal.innerHTML = `
      <div class="large-modal-inner">
        <div class="large-modal-header">
          <h2>Declined Operations</h2>
          <input id="declined-search" type="text" placeholder="Search declined ops…" />
          <button id="declined-close">Close</button>
        </div>
        <div id="declined-jobList" class="job-list"></div>
      </div>
    `;
    document.body.appendChild(modal);
  }

  const closeBtn = modal.querySelector('#declined-close');
  if (!closeBtn._wired) {
    closeBtn.addEventListener('click', () => { modal.style.display = 'none'; });
    closeBtn._wired = true;
  }

  const listDiv = modal.querySelector('#declined-jobList');
  const searchInput = modal.querySelector('#declined-search');

  listDiv.innerHTML = '';

  const q = query(ref(database, 'data'), orderByChild('Status'), equalTo('Declined'));
  const snap = await get(q);
  const jobs = [];

  if (snap.exists()) {
    const val = snap.val() || {};
    Object.keys(val).forEach((k) => {
      if (k === 'lastUpdated') return;
      const j = val[k];
      if (j && j.Status === 'Declined') jobs.push(j);
    });
  }

  jobs.sort((a, b) => {
    const da = new Date(a.Schedule_Date || a.Start_Date || 0).getTime();
    const db = new Date(b.Schedule_Date || b.Start_Date || 0).getTime();
    return db - da;
  });

  const frag = document.createDocumentFragment();
  for (const job of jobs) {
    const row = shell.createOperationRow(job);
    if (!row.hasAttribute('data-jobinfo')) row.setAttribute('data-jobinfo', JSON.stringify(job));
    if (!row.hasAttribute('data-id')) row.setAttribute('data-id', job.Job_ID || '');
    frag.appendChild(row);
  }
  listDiv.appendChild(frag);

  if (!listDiv._wired) {
    listDiv.addEventListener('click', throttle(shell.opCheck, 200));
    listDiv._wired = true;
  }

  if (!searchInput._wired) {
    searchInput.addEventListener('input', () => filterDeclinedList(searchInput.value));
    searchInput._wired = true;
  }
  // The box keeps its text between openings; filter the fresh list by it.
  filterDeclinedList(searchInput.value);

  modal.style.display = 'block';
}

function filterDeclinedList(queryText) {
  const q = (queryText || '').trim().toLowerCase();
  const rows = document.querySelectorAll('#declined-jobList .job-item');

  rows.forEach((row) => {
    try {
      const data = JSON.parse(row.getAttribute('data-jobinfo') || '{}');
      delete data.Notes;
      const hay = JSON.stringify(data).toLowerCase();
      // '' not 'flex': these are grid .op-table-row rows (see searchJobs()).
      row.style.display = q === '' || hay.includes(q) ? '' : 'none';
    } catch {
      row.style.display = '';
    }
  });
}

document.getElementById('open-declined-ops').addEventListener('click', openDeclinedOperationsModal);


document.getElementById('print-job-table').addEventListener('click', () => {
  printUnfilteredRowsInTable('jobList');
});


document.getElementById('reset-exclude').addEventListener('click', () => {
  const excludedJobs = document.querySelectorAll('.excluded');
  excludedJobs.forEach(job => {
    console.log(job);
    const row = job.closest('.job-item');
    row.style.backgroundColor = 'initial';
    row.style.opacity = '1';
    row.classList.remove('excluded');
    job.querySelector('.exclude-checkbox').checked = false;
  });
  document.getElementById('reset-exclude').style.display = "none";
});

async function printUnfilteredRowsInTable(table) {
  try {
    const jobListDiv = document.getElementById(table);
    const customerData = await shell.getAllCustomerData(); // Fetch all customers
    const jobRows = jobListDiv.children;
    const newWindow = window.open('', '_blank');

    let techs = '';
    let techNotes = '';

    if (table === 'jobList') {
      techs = '<th>Tech</th>';
      techNotes = '<th>Notes</th>';
    }

    let tableContent = `
      <html>
        <head>
          <title>Operation List</title>
          <style>
            body {
              margin: 1in;
              font-family: Arial, sans-serif;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid black;
              padding: 8px;
              text-align: center;
            }
            tr:nth-child(even) {
              background-color: #f2f2f2;
            }
            th {
              background-color: #4CAF50;
              color: white;
            }
          </style>
        </head>
        <body>
          <h2>Job List</h2>
          <table>
            <thead>
              <tr>
                <th>Customer</th>
                <th>Boat</th>
                <th>Description</th>
                <th>Date</th>
                ${techs}
                ${techNotes}
              </tr>
            </thead>
            <tbody>`;

    for (let row of jobRows) {
      if (
        !row.classList.contains('filtered') &&
        !row.classList.contains('haul-item') &&
        !row.classList.contains('complete-job') &&
        !row.classList.contains('excluded') &&
        row.style.display !== 'none'
      ) {
        const jobData = JSON.parse(row.getAttribute('data-jobInfo'));
        const customerId = jobData.Customer_ID;
        const boatId = jobData.Boat_ID;

        // Find the matching customer in customerData array
        const customerObj = customerData.find((c) => c.Customer_ID === customerId);
        // Equipment (internal) work has no customer record ("equipment"): use the names on the op.
        const customerName = !customerObj ? (jobData.Customer_Name || '')
          : customerObj.First_Name !== '' ? customerObj.Last_Name + ', ' + customerObj.First_Name : customerObj.Last_Name;

        // Find the matching boat under that customer
        const boatObj = customerObj?.Boats ? customerObj.Boats[boatId] : null;
        const boatName = boatObj ? boatObj.Boat_Name : (customerObj ? '' : jobData.Boat_Name || '');

        const boatLength = parseFloat(boatObj?.Boat_Length) || 0;
        const boatBeam = parseFloat(boatObj?.Boat_Beam) || 0;
              
        const quantity = (boatLength > 0 && boatBeam > 0) 
        ? parseFloat(((boatLength * boatBeam) * 0.85 / 350).toFixed(2))
        : 0;      

        const bottomPaintProduct = boatObj?.Bottom_Paint_Product || 'Not on file';
        const bottomPaintColor = boatObj?.Bottom_Paint_Color || '';       

        let description = '';
        if (table === 'jobList') {

          description = row.querySelector('.op-code-short-description-p')?.textContent || '';

          if (description.toLowerCase().includes('bottom paint')) {
              description = escapeHTML(description) + `<br><br>Paint: ${escapeHTML(bottomPaintProduct)}<br>Color: ${escapeHTML(bottomPaintColor)}<br>Qty: ${quantity}`;
          
          }else{

            description = escapeHTML(row.querySelector('.op-code-short-description-p')?.textContent || '');

          }
          
        } else if (table === 'tech-list') {

          description = escapeHTML(row.querySelector('.description-info').querySelector('p')?.textContent || '');

        }

        let date = row.querySelector('.start-date-info')?.textContent || '';
        date = date.replace('Start Date: ', '');

        let techData = '';
        let noteData = '';

        let tech = row.querySelector('.tech-info')?.dataset.selectedTech || '';
        let techNote = jobData.Tech_Notes || '';

        if (table === 'jobList') {
          techData = '<td>' + escapeHTML(tech) + '</td>';
          noteData = '<td>' + escapeHTML(techNote) + '</td>';
        }

        tableContent += `
          <tr>
            <td>${escapeHTML(customerName)}</td>
            <td>${escapeHTML(boatName)}</td>
            <td>${description}</td>
            <td>${escapeHTML(date)}</td>
            ${techData}
            ${noteData}
          </tr>`;
      }
    }

    tableContent += `
            </tbody>
          </table>
        </body>
      </html>`;

    newWindow.document.write(tableContent);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();

    newWindow.onafterprint = () => {
      newWindow.close();
    };
  } catch (error) {
    console.error('Error printing unfiltered job rows:', error);
  }
}
